import Edge from "./Edge";
import * as utils from '../../../utils/utils';
import * as THREE from 'three';
import FaceVertex from "./FaceVertex";
import SmartroofFace from "./SmartroofFace";
import RectangleObstruction from "../Rectangle";
import TurretDormer from "./dormers/TurretDormer";
import Drawface from "./DrawFace";
import { SmartroofModel } from "./SmartroofModel";
import Tree from '../Tree';
import ACDB from '../../ac/ACDB';
import DCDB from '../../ac/DCDB';
import SafetyLine from '../SafetyLine';
import Handrail from '../Handrail';
import AcCable from '../cable/AcCable';
import Walkway from '../Walkway';
import Inverter from '../../ac/Inverter';
import FlatDormer from './dormers/FlatDormer';
import HippedDormer from './dormers/HippedDormer';
import Dormer from './Dormer';
import HybridInverter from '../../ac/HybridInverter';
import Subarray from '../../subArray/Subarray';
import { CREATED_STATE, DELETED_STATE, PENTOOL_ROOF_FACE } from "../../../coreConstants";
import { CSG } from "../../../utils/csg-lib";
import { MINIMUM_NUMBER_OF_POINTS } from "../../subObjects/TextBox";
import EastWestRack from "../../../lib/EastWestRacking";
import * as notificationsAssistant from '../../../../componentManager/notificationsAssistant';


export default class PenToolRoofFace extends SmartroofFace{
    constructor(stage, parent, vertices = [], roofFaceVertices = [], edges = [], tilt = 20, coreHeight = 0, setbackInside = [[]], fold = null, primaryEdge = null, setbackVertices = [[]]){
        // for (let i = 0; i < vertices.length; i++) {
        //     vertices[i].z = coreHeight;
        // }//change this
        super(stage, vertices, edges, tilt, coreHeight, setbackInside, fold, null);
        this.outlinePoints = [];
        this.type = PENTOOL_ROOF_FACE;
        this.roofFaceVertices = roofFaceVertices;
        this.isParentPenToolRoofModel = true;
        this.primaryEdge = primaryEdge;
        this.edges = [];
        this.parent = parent;
        this.setbackVertices = setbackVertices;
        this.adjustFaceAllowed = false;
        this.drawnVertices = [];
        this.stage.ground.faces.add(this);
        this.azimuth = 0;
        this.plane = this.createPlaneFromPointsAndTilt(vertices[0], tilt);
        // this.makeEdges();
        this.stage.stateManager.add({
            uuid: this.uuid,
            getStateCb: () => CREATED_STATE,
        });
    }
    makeEdges() {
        for (let i = 0; i < this.roofFaceVertices.length; i++) {
            const edge = new Edge(this, this.stage, this.roofFaceVertices[i].vertex, this.roofFaceVertices[(i + 1) % this.roofFaceVertices.length].vertex, false);
            edge.makeEdgeMesh();
            this.edges.push(edge);
        }

    }
    createEdges() {
        this.edges.forEach(edge => {
            edge.removeObject();
        })
        this.edges = [];
        // const vertices = this.get3DVertices();
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            const edge = new Edge(this, this.stage, this.roofFaceVertices[i], this.roofFaceVertices[(i + 1) % len], true, i, (i + 1) % len, false);
            this.edges.push(edge);
        }
        if(this.primaryEdge === null) this.primaryEdge = this.edges[0];
    }

    removeEdges(){
        for (let i = 0, len = this.edges.length; i < len; i += 1) {
            this.edges[i].removeObject();
        }
        this.edges = [];
    }
    removeObject(deselect = true) {
        // First deleting child subarray before other objects so that deleting walkways or other
        // objects don't refresh the subarray unnecessarily
        const childSubarrays = this.getChildSubarrays();
        for (let i = 0, len = childSubarrays.length; i < len; i += 1) {
            childSubarrays[i].removeObject();
        }

        const i = 0;
        while (this.getChildren().length > i) {
            this.getChildren()[i].removeObject();
        }

        // NOTE: deSelect should be after save since it will disable
        // drag controls and stop Undo/Redo container
        if (this.stage.selectionControls.getSelectedObject() === this) {
            this.stage.selectionControls.setSelectedObject(this.stage.ground);
        }

        this.stage.sceneManager.scene.remove(this.objectsGroup);

        this.fold = null;
        // remove measurements
        // if (this.polygonMeasurement) {
        //     this.polygonMeasurement.remove();
        // }

        for(let i = 0; i < this.roofFaceVertices.length; i++){
            if(this.roofFaceVertices[i].zValueMap.size === 0){
                this.parent.parent.pointsMap.delete(`${this.roofFaceVertices[i].vertex.x.toFixed(4)},${this.roofFaceVertices[i].vertex.y.toFixed(4)}`);
                this.parent.faceVertices.forEach((vertex, index) => {
                    if(vertex.vertex.x === this.roofFaceVertices[i].vertex.x && vertex.vertex.y === this.roofFaceVertices[i].vertex.y){
                        this.parent.faceVertices.splice(index, 1);
                    }
                });
                this.roofFaceVertices[i].removeObject();
            }
        }
        this.parent.roofFaces.forEach((face, index) => {
            if(face.uuid === this.uuid){
                this.parent.roofFaces.splice(index, 1);
            }
        });
        
        if (this.getParent() !== null) {
            this.getParent().removeChild(this);
        }

        // from base object
        this.removeDimensions();

        if (this.faceMesh) {
            this.faceMesh.geometry.dispose();
            this.stage.sceneManager.scene.remove(this.faceMesh);
        }

        // remove object from hover manager
        this.stage.quadTreeManager.removeObject(this);
        this.stage.ground.faces.delete(this);
        
        this.stage.stateManager.add({
            uuid: this.uuid,
            getStateCb: () => DELETED_STATE,
        });


        if (deselect) {
            this.stage.selectionControls.setSelectedObject(this.stage.ground);
        }
    }

    moveEdgesWithoutConsequences(deltaX, deltaY, deltaZ) {
        for (let i = 0; i < this.edges.length; i++) {
            this.edges[i].moveObjectWithoutConsequences(deltaX, deltaY);
        }
    }

    moveObject(deltaX, deltaY, deltaZ = 0) {

        for (let i = 0, l = this.vertices.length; i < l; i += 1) {
            this.vertices[i].add(new THREE.Vector3(deltaX, deltaY, deltaZ));
        }
        // for (let i = 0, l = this.editedVertices.length; i < l; i += 1) {
        //     this.editedVertices[i].add(new THREE.Vector3(deltaX, deltaY, deltaZ));
        // }

        // if (this.oldVertices) {
        //     for (let i = 0, l = this.oldVertices.length; i < l; i += 1) {
        //         this.oldVertices[i].add(new THREE.Vector3(deltaX, deltaY, deltaZ));
        //     }
        // }
        if (this.faceMesh && this.isValidFace()) {
            this.faceMesh.geometry.translate(deltaX, deltaY, deltaZ);
        }

        const meshGeom = this.faceMesh.geometry.clone();
        meshGeom.computeVertexNormals();
        this.faceMeshCSG = CSG.fromGeometry(meshGeom);

        // this.updateRoofFaceVertices(this.vertices);

        // update measurement
        // // TODO this will not work in multy select
        // if (this.stage.selectionControls.getSelectedObject() === this && this.isValidFace()) {
        //     if (this.polygonMeasurement && this.oldVertices) this.polygonMeasurement.updateMeasurements(this.oldVertices);
        // }

        // update dimensions
        this.moveDimensions(deltaX, deltaY, deltaZ);

        // update children
        const children = this.getChildren();
        for (let i = 0, l = children.length; i < l; i += 1) {
            children[i].moveObject(deltaX, deltaY, deltaZ, false);
        }
        this.hideRafter(); // hide rafters while the smartroof is dragged
        this.updateGeometry();
        this.saveState();
    }

    disposeRafters(){
        if (this.rafterEnabled && !this.stage.visualManager.in3D) {
            // remove the rails and rafters when the roof is dynamically updated
            this.disposeAttachments();
            this.disposeRails();
        }
    }

    updateGeometry() {
        if (!this.azimuth && !this.isDeleted && this.isValid) {
            this.azimuth = this.findAzimuth();
        }
        this.setbackInsideMesh.position.z = 0.01;
        this.saveState();
    }

    findAzimuth() {
        let azimuth = this.azimuth;
        // const edgeAzimuth = (this.checkClockwiseForEdges()) ? (this.findAngle(new THREE.Vector2(this.primaryEdge.point1.x,this.primaryEdge.point1.y + 1),this.primaryEdge.point1, this.primaryEdge.point2) ):(this.findAngle(new THREE.Vector2(this.primaryEdge.point2.x,this.primaryEdge.point2.y + 1),this.primaryEdge.point2, this.primaryEdge.point1));
        // azimuth = edgeAzimuth.toFixed(2);

        return azimuth;
    }

    getPerpendicularAngleFromYAxis(point1, point2) {
        // Create vectors from the points
        const vec1 = new THREE.Vector3(point1.x, point1.y, point1.z);
        const vec2 = new THREE.Vector3(point2.x, point2.y, point2.z);
      
        // Calculate the direction vector of the line
        const direction = new THREE.Vector3().subVectors(vec2, vec1);
      
        // Calculate the perpendicular vector in the XY plane
        const perpendicular = new THREE.Vector3(-direction.y, direction.x, 0).normalize();
      
        // Create a vector representing the positive y-axis
        const yAxis = new THREE.Vector3(0, 1, 0);
      
        // Calculate the angle between the perpendicular vector and the y-axis
        let angle = perpendicular.angleTo(yAxis);
      
        // Determine if the angle should be adjusted (for clockwise rotation from y-axis)
        if (perpendicular.x < 0) {
          angle = 2 * Math.PI - angle;
        }
      
        // Convert the angle to degrees
        angle = THREE.MathUtils.radToDeg(angle);
        
        // Ensure the angle is between 0 and 360
        return (angle + 360) % 360;
      }
    updateRoofFaceVertices(vertices){
        if(vertices.length > 0){
            vertices.forEach((vertex, index) => {
                const v = this.parent.parent.pointsMap.get(`${vertices[index].x.toFixed(4)},${vertices[index].y.toFixed(4)}`);
                v.vertex = vertices[index];
                v.zValueMap.set(this.uuid, vertices[index].z);

            });
        }
    }

    onSelect() {
        this.isSelected = true;
        if (this.isValidFace()) {
            for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
                this.roofFaceVertices[i].showObject();
            }
            this.showSetback();
            this.createEdges();
            this.showEdges();
        }
        this.highlightOnHover()
    }

    deSelect() {
        this.isSelected = false;
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            this.roofFaceVertices[i].hideObject();
        }
        this.hideSetback();
        this.hideEdges();
        this.unHighlight();
    }

    initDrawingMode() {
        // Initialize drawing by providing event handlers and mesh materials
        this.stage.drawManager.initialize(
            this,
            this.onComplete.bind(this),
            this.onCancel.bind(this),
        );
    }
    getPlacingInformation(drawingVertices) {
        const response = {};
        response.errors = [];
        response.pointUnplaceableError = null;
        return response;
    }

    setAzimuth(azimuth) {
        this.azimuth = azimuth;
        this.salesAzimuth = this.azimuth;
    }

    updateAzimuth(azimuth) {
        let minDiff = 360;
        let primaryEdge = null;
        let tempAzimuth = azimuth;
        this.edges.forEach(edge => {
            const edgeAzimuth = (this.checkClockwiseForEdges()) 
            ? (this.getPerpendicularAngleFromYAxis(edge.point1, edge.point2))
            : (this.getPerpendicularAngleFromYAxis(edge.point2, edge.point1));
            const diff = (Math.abs(edgeAzimuth - azimuth) > Math.abs(edgeAzimuth + 360 - azimuth)) ? Math.abs(edgeAzimuth + 360 - azimuth) : Math.abs(edgeAzimuth - azimuth);
            if (diff < minDiff) {
                minDiff = diff;
                primaryEdge = edge;
                tempAzimuth = edgeAzimuth;
            }
        });
        if(minDiff > 30) {
            tempAzimuth = azimuth;
        }
        this.primaryEdge = primaryEdge;
        this.azimuth = Number(tempAzimuth.toFixed(2)); // Round to two decimal places
    }

    azimuthToNormalVector(azimuthDegrees) {
    // Convert azimuth from degrees to radians
    const azimuthRadians = azimuthDegrees * Math.PI / 180;

    // Calculate x and y components of the normal vector
    const x = Math.sin(azimuthRadians);
    const y = Math.cos(azimuthRadians);

    // Return the normal vector
    return new THREE.Vector3(x, y, 0);
}
    findAngle(p0,p1,p2) {
        var a = Math.pow(p1.x-p0.x,2) + Math.pow(p1.y-p0.y,2),
            b = Math.pow(p1.x-p2.x,2) + Math.pow(p1.y-p2.y,2),
            c = Math.pow(p2.x-p0.x,2) + Math.pow(p2.y-p0.y,2);
        var angleInRadians = Math.acos( (a+b-c) / Math.sqrt(4*a*b) );
        var angleInDegrees = angleInRadians * (180 / Math.PI);

        var crossProduct = (p1.x - p0.x) * (p2.y - p0.y) - (p1.y - p0.y) * (p2.x - p0.x);
        if (crossProduct < 0) {
            angleInDegrees = 360 - angleInDegrees;
        }
        angleInDegrees -= 90;
        if (angleInDegrees < 0) {
            angleInDegrees += 360;
        }
        return angleInDegrees
        
    }

    checkClockwiseForEdges() {
        let sum = 0;
        for (let i = 0; i < this.edges.length; i++) {
            sum += (this.edges[i].point2.x - this.edges[i].point1.x) * (this.edges[i].point2.y + this.edges[i].point1.y);
        }
        return sum > 0;
    }

    findAzimuthForEdge(edge) {
        // getting normal for each pair
        let azimuth = 180;
        let angle = utils.toDegrees(Math.atan2((edge[0].y - edge[1].y), -(edge[0].x - edge[1].x)));
        // atan2 returns between -pi and pi and we want between 0 and 360. 0 being in North
        angle += 180;
        azimuth = angle.toFixed(2);
        if (azimuth > 359.99) {
            azimuth = 0;
        }

        return azimuth;
    }
    //function to update this.plane 
    updatePlane(){
        const primaryEdge = (this.primaryEdge !== null) ? this.primaryEdge : this.edges[0];
        const primaryVertex = this.vertices.find(vertex => vertex.x === primaryEdge.outlinePoint2.getPosition().x && vertex.y === primaryEdge.outlinePoint2.getPosition().y);
        this.plane = this.createPlaneFromPointsAndTilt(primaryVertex, this.tilt);
    }
    tiltChange(arg) {
        this.hideSetback();
        const validTilt = this.getValidTilt(arg);
        this.tilt = validTilt;
        const primaryEdge = (this.primaryEdge !== null) ? this.primaryEdge : this.edges[0];
        const primaryVertex = this.vertices.find(vertex => vertex.x === primaryEdge.outlinePoint2.getPosition().x && vertex.y === primaryEdge.outlinePoint2.getPosition().y);
        this.plane = this.createPlaneFromPointsAndTilt(primaryVertex, validTilt);
        const verticesHeight = [];
        let minZ = 100000;
        this.vertices.forEach((vertex) => {
            const zValue = this.getVertexHeight(vertex);
            minZ = Math.min(minZ, zValue);
            verticesHeight.push(zValue);
        });

        this.vertices.forEach((vertex, index) => {
            vertex.z = verticesHeight[index] - minZ + this.coreHeight;
        });
        
        const coplanarVertices = SmartroofModel.makeCoplanar(this.vertices, this);
        this.vertices = coplanarVertices;

        this.updateRoofFaceVertices(this.vertices);
        // this.parent.attachedObjects.attachments.forEach(attachment => {
        //     attachment.moveAttached = true;
        // })
        // this.parent.attachedObjects.hideAttachments();
        this.hideEdges();
        // this.parent.updateGeometry();
        // this.parent.getAllSmartroofIntersections();
        this.showEdges();
    }

    getVertexHeight(vertex) {
        let intersection = new THREE.Vector3();
        this.plane.projectPoint(vertex, intersection);
        // Return the z value of the intersection point
        return intersection.z;
    }

    updateHeight(deltaZ) {
        // update outline points without consequences
        for (let i = 0, l = this.vertices.length; i < l; i += 1) {
            this.vertices[i].add(new THREE.Vector3(0, 0, deltaZ));
        }

        this.coreHeight += deltaZ;

        // update dimensions
        this.moveDimensions(0, 0, deltaZ);

        // update children
        const children = this.getChildren();
        for (let i = 0, l = children.length; i < l; i += 1) {
            if (children[i].isTemplate) {
                children[i].updateHeight(parseFloat(children[i].coreHeight) + parseFloat(deltaZ));
                children[i].hideTestEdges();
            }
            else children[i].moveObject(0, 0, deltaZ);
            // console.log('children[i]: ', children[i].isTemplate);
        }
        // this.parent.attachedObjects.attachments.forEach(attachment => {
        //     attachment.moveAttached = true;
        // })
        // this.parent.attachedObjects.hideAttachments();
        this.hideRafter(); // hide rafters while the smartroof is dragged
        this.updateRoofFaceVertices(this.vertices);
        this.parent.updateGeometry();
        this.saveState();
    }

    placeChildren() {
        const children = this.getChildren();
        for (let i = 0, l = children.length; i < l; i += 1) {
            children[i].placeObject();
            //EASTWEST-RESTRICTION
            // if (children[i] instanceof EastWestRack && this.tilt > 0) {
            //     children[i].removeObject();
            //     children[i].saveState();
            //     this.stage.eventManager.eastWestRackingNotPlacebleError();
            //     //throw new Error('East West Racking cannot be placed over Tilted Surfaces');
            // }
            // else {
            //     children[i].placeObject();
            // }
        }
    }

    updateSubarray(){
        //remove all the subarrays
        this.getChildren().forEach(child => {
            if(child instanceof Subarray){
                child.removeObject();
            }
        }
        )
    }
    
    heightChange(arg, setbackFlag = false) {
        this.hideSetback();
        this.updateHeight(arg - this.coreHeight);
        this.coreHeight = arg;
        this.hideEdges();
        this.getParent().placeObject();
        this.showEdges();
    }

    getHeight(){
        return this.coreHeight;
    }

    getPlaneNormal(tilt, point1, point2) {
        const planeNormalAngle = utils.deg2Rad(90 + this.getValidTilt(tilt));
        const planeNormal = (this.getInwardHorizontalNormal(point1, point2).applyAxisAngle(this.getEdgeVector(point1, point2), planeNormalAngle)).normalize();
        return planeNormal;
    }

    getInwardHorizontalNormal(point1, point2) {
        return (new THREE.Vector3(point1.y - point2.y, point2.x - point1.x, 0)).normalize();
    }
    getEdgeVector(point1, point2) {
        return (new THREE.Vector3(point2.x - point1.x, point2.y - point1.y, 0)).normalize();
    }
    
    createPlaneFromPointsAndTilt(point2, tiltInDegrees) {
        // Create a plane from the normal vector and a point
        // let plane = new THREE.Plane().setFromNormalAndCoplanarPoint(this.getPlaneNormal(tiltInDegrees, point1, point2), point1);
        let plane = new THREE.Plane().setFromNormalAndCoplanarPoint(this.getPlaneNormalFromAzimuth(tiltInDegrees, this.azimuth, point2), point2);
        // this.objectsGroup.add(new THREE.PlaneHelper(plane, 20, 0x0000ff));
        return plane;
    }

    getPlaneNormalFromAzimuth(tilt, azimuth, point) {
        // Convert azimuth to radians
        const azimuthRad = utils.deg2Rad(azimuth);

        // Adjusting the calculation for edge direction vector based on the new definition of azimuth
        // Since azimuth is now the angle between the edge's perpendicular and the +ve Y-axis, we adjust by -90 degrees
        const adjustedAzimuthRad = azimuthRad - utils.deg2Rad(90);

        // Calculate edge direction vector based on the adjusted azimuth
        const edgeDirection = new THREE.Vector3(Math.sin(adjustedAzimuthRad), Math.cos(adjustedAzimuthRad), 0).normalize();
        //find a point on the edge
        const edgePoint = new THREE.Vector3(point.x + edgeDirection.x, point.y + edgeDirection.y, point.z);

        // Calculate the normal vector based on the edge direction vector and the tilt
        const planeNormalAngle = utils.deg2Rad(90 +this.getValidTilt(tilt));
        const planeNormal = (this.getInwardHorizontalNormal(point, edgePoint).applyAxisAngle(edgeDirection, planeNormalAngle)).normalize();

        return planeNormal;
    }

    getEdges(){
        const edges = [];
        this.vertices.forEach((vertex, index) => {
            edges.push([new THREE.Vector2(vertex.x, vertex.y), new THREE.Vector2(this.vertices[(index + 1) % this.vertices.length].x, this.vertices[(index + 1) % this.vertices.length].y)]);
        });
        return edges;
    }
    updateVertices(){
        this.vertices = [];
        if(this.roofFaceVertices.length === 0) return;
        this.roofFaceVertices.forEach((vertex) => {
            let z = vertex.zValueMap.get(this.uuid);
            if(z === undefined) z = this.coreHeight;
            this.vertices.push(new THREE.Vector3(vertex.vertex.x, vertex.vertex.y, z));
        });
    }

    saveObject(isCopy = false) {
        const polygonModelData = {
            type: SmartroofFace.getObjectType(),
            children: [],
        };

        // save id and name
        polygonModelData.id = this.id;
        polygonModelData.name = this.name;
        if (isCopy) {
            polygonModelData.uuid = this.uuid;
        }
        polygonModelData.tilt = this.getValidTilt(this.tilt);
        polygonModelData.rafterEnabled = this.rafterEnabled;
        polygonModelData.rafterOrientation = this.rafterOrientation;
        polygonModelData.rafterSpacing = this.rafterSpacing;
        polygonModelData.rafterOffset = this.rafterOffset;
        polygonModelData.isDeleted = this.isDeleted;
        polygonModelData.coreHeight = this.coreHeight;
        polygonModelData.azimuth = this.azimuth;
        polygonModelData.setbackInside = this.setbackInside;
        polygonModelData.attachmentSpacingMultiplier = this.attachmentSpacingMultiplier;
        polygonModelData.attachmentType = this.attachmentType;
        polygonModelData.updatedAttachmentRow = this.updatedAttachmentRow;
        polygonModelData.attachmentRow = this.attachmentRow;
        polygonModelData.primaryEdge = (this.primaryEdge === null)? null: this.primaryEdge.edgeHash;

        // polygonModelData.setbackOutside = this.setbackOutside;
        polygonModelData.ignored = this.ignored;
        polygonModelData.placable = this.placable;
        polygonModelData.isValid = this.isValid;
        // if (this.outerEdge) {
        //     polygonModelData.outerEdgeId = this.outerEdge.id;
        // }
        if (this.fold) {
            polygonModelData.foldId = this.fold.id;
        }

        // saving roofFaceVertices
        polygonModelData.roofFaceVertices = [];
        for(let i = 0; i < this.roofFaceVertices.length; i++){
            const z = this.roofFaceVertices[i].zValueMap.get(this.uuid);
            polygonModelData.roofFaceVertices.push([this.roofFaceVertices[i].vertex.x, this.roofFaceVertices[i].vertex.y, z]);
        }

        // saving drawVertices
        polygonModelData.drawVertices = [];
        for(let i = 0; i < this.drawnVertices.length; i++){
            polygonModelData.drawVertices.push([this.drawnVertices[i].x, this.drawnVertices[i].y, this.drawnVertices[i].z]);
        }

        // saving setbackVertices
        polygonModelData.setbackVertices = this.setbackVertices
            .map(polygon => polygon
                .map(vector => [vector.x, vector.y, vector.z]));

        // saving children
        const children = this.getChildren();
        for (let i = 0, len = children.length; i < len; i += 1) {
            polygonModelData.children.push(children[i].saveObject());
        }
        
        polygonModelData.errors = this.errors;
        return polygonModelData;
    }

    loadObject(polygonModelData, isPaste = false) {
        
        if (!PenToolRoofFace.validateObject(polygonModelData).isValid) {
            this.stage.stateManager.add({
                uuid: this.uuid,
                getStateCb: () => DELETED_STATE,
            });

            this.stage.sceneManager.scene.remove(this.objectsGroup);

            if (this.getParent() !== null) {
                this.getParent().removeChild(this);
            }

            this.stage.eventManager
                .customErrorMessage('Polygon data invalid: Polygon removed');
            return;
        }
        if (!isPaste) {
            this.id = polygonModelData.id;
            this.name = polygonModelData.name;
        }
        this.tilt = this.getValidTilt(polygonModelData.tilt);
        this.rafterEnabled = (polygonModelData.rafterEnabled === undefined) ? (this.rafterEnabled) : (polygonModelData.rafterEnabled);
        this.rafterOrientation = (polygonModelData.rafterOrientation === undefined) ? (this.rafterOrientation) : (polygonModelData.rafterOrientation);
        this.rafterSpacing = (polygonModelData.rafterSpacing === undefined) ? (this.rafterSpacing) : (polygonModelData.rafterSpacing);
        this.rafterOffset = (polygonModelData.rafterOffset === undefined) ? (this.rafterOffset) : (polygonModelData.rafterOffset);
        this.attachmentSpacingMultiplier = (polygonModelData.attachmentSpacingMultiplier === undefined) ? (this.attachmentSpacingMultiplier) : (polygonModelData.attachmentSpacingMultiplier);
        this.attachmentType = (polygonModelData.attachmentType === undefined) ? (this.attachmentType) : (polygonModelData.attachmentType);
        this.updatedAttachmentRow = (polygonModelData.updatedAttachmentRow === undefined) ? (this.updatedAttachmentRow) : (polygonModelData.updatedAttachmentRow);
        this.attachmentRow = (polygonModelData.attachmentRow === undefined) ? (this.attachmentRow) : (polygonModelData.attachmentRow);
        this.isDeleted = (polygonModelData.isDeleted === undefined) ? (this.tilt === 89.9) : polygonModelData.isDeleted;
        this.azimuth = polygonModelData.azimuth;
        // this.heightChange(polygonModelData.coreHeight);
        this.coreHeight = polygonModelData.coreHeight;
        this.ignored = polygonModelData.ignored;
        this.placable = polygonModelData.placable;
        this.edge = polygonModelData.edge;
        this.outerEdgeHeight = polygonModelData.outerEdgeHeight;
        this.isValid = polygonModelData.isValid;
        if (polygonModelData.foldId) {
            this.foldId = polygonModelData.foldId;
        }


        this.updateOldVertices();
        // load drawVertices
        if (polygonModelData.drawVertices) {
            this.drawnVertices = polygonModelData.drawVertices
                .map(values => new THREE.Vector3(...values));
        }

        // Setting the setback vertices

        // New design
        if (polygonModelData.setbackVertices &&
            Array.isArray(polygonModelData.setbackVertices) &&
            polygonModelData.setbackVertices.every(group => Array.isArray(group)) &&
            polygonModelData.setbackVertices.every(group => group
                .every(values => Array.isArray(values)))) {
            this.setbackVertices = polygonModelData.setbackVertices
                .map(polygon => polygon
                    .map(values => new THREE.Vector3(...values)));
            this.setbackInside = polygonModelData.setbackInside;
        }
        // Old design
        else if (Array.isArray(polygonModelData.roofFaceVertices)) {
            this.setbackVertices = [polygonModelData.roofFaceVertices
                .map(values => new THREE.Vector3(...values))];
            this.setbackInside = [polygonModelData.setbackInside];
        }
        else {
            console.error('unidentified design type', polygonModelData.setbackVertices, polygonModelData.roofFaceVertices);
        }

        // create polygon measurement
        // if (this.isValid) {
        //     this.polygonMeasurement = new PolygonMeasurement(this.oldVertices, this, this.stage, false);
        // }

        // update geometry

        const tempVertices = [];
        const tempSavedVertices = [];

        this.oldVertices.forEach((vertex) => {
            tempVertices.push(new THREE.Vector3(vertex.x, vertex.y, vertex.z));
        });
        this.oldVertices.forEach((vertex) => {
            tempSavedVertices.push(new THREE.Vector3(vertex.x, vertex.y, vertex.z));
        });

        this.editedVertices = (tempSavedVertices.length > 0) ? tempSavedVertices : tempVertices;

        this.createEdges();
        this.edges.forEach(edge => {
            if(edge.edgeHash === polygonModelData.primaryEdge){
                this.primaryEdge = edge;
            }
        });
        const primaryEdge = (this.primaryEdge !== null) ? this.primaryEdge : this.edges[0];
        const primaryVertex = this.vertices.find(vertex => vertex.x === primaryEdge.outlinePoint2.getPosition().x && vertex.y === primaryEdge.outlinePoint2.getPosition().y);
        this.plane = this.createPlaneFromPointsAndTilt(primaryVertex, this.tilt);
        // this.tiltChange(this.tilt);
        this.updateSetback();
        this.updateGeometry();
        const {children} = polygonModelData;
        for (let i = 0, len = children.length; i < len; i += 1) {
            let currentObject;
            try {
                if (this.stage.checkObjectTypePolygonModel(children[i])) {
                    const polygonModel = this.stage.initializePolygonModel();
                    currentObject = polygonModel;
                    this.addChild(polygonModel);
                    polygonModel.loadObject(children[i], isPaste);
                    if (polygonModel.getParent() !== this) {
                        console.error('PolygonModel: Mismatch in parent while loading PolygonModel');
                    }
                }
                else if (children[i].type === RectangleObstruction.getObjectType()) {
                    const rectangleObstruction = new RectangleObstruction(this.stage);
                    currentObject = rectangleObstruction;
                    this.addChild(rectangleObstruction);
                    rectangleObstruction.loadObject(children[i], isPaste);
                    if (rectangleObstruction.getParent() !== this) {
                        console.error('PolygonModel: Mismatch in parent while loading PolygonModel');
                    }
                }
                else if (children[i].type === TurretDormer.getObjectType()) {
                    const turretDormer = new TurretDormer(this.stage);
                    currentObject = turretDormer;
                    this.addChild(turretDormer);
                    turretDormer.loadObject(children[i], isPaste);
                    if (turretDormer.getParent() !== this) {
                        console.error('SmartRoof Dormer: Mismatch in parent while loading dormer');
                    }
                }
                else if (children[i].type === Drawface.getObjectType()) {
                    const dormer = new Drawface(this.stage);
                    currentObject = dormer;
                    this.addChild(dormer);
                    dormer.loadObject(children[i], isPaste);
                }
                else if (children[i].type === SmartroofModel.getObjectType() && children[i].dormerType === 'FlatDormer') {
                    const dormer = new Drawface(this.stage);
                    currentObject = dormer;
                    dormer.isTemplate = true;
                    dormer.type = 'FlatDormer';
                    dormer.snapHeight = true;
                    dormer.tilt = 0;
                    dormer.minTilt = 0;
                    dormer.loadObjectFlatDormerBackwardsComp(children[i], isPaste);
                }
                else if (children[i].type === SmartroofModel.getObjectType()) {
                    const dormer = new SmartroofModel(this.stage);
                    currentObject = dormer;
                    this.addChild(dormer);
                    dormer.loadObject(children[i], isPaste);
                    if (dormer.getParent() !== this) {
                        console.error('SmartRoof Dormer: Mismatch in parent while loading dormer');
                    }
                }
                else if (children[i].type === Dormer.getObjectType()) {
                    const dormer = new SmartroofModel(this.stage);
                    currentObject = dormer;
                    this.addChild(dormer);
                    this.loadDormerBackwardsCompatibility(dormer, children[i]);
                    if (dormer.getParent() !== this) {
                        console.error('GabledDormer: Mismatch in parent while loading dormer');
                    }
                }
                else if (children[i].type === FlatDormer.getObjectType()) {
                    const dormer = new SmartroofModel(this.stage);
                    currentObject = dormer;
                    this.addChild(dormer);
                    this.loadDormerBackwardsCompatibility(dormer, children[i]);
                    if (dormer.getParent() !== this) {
                        console.error('FlatDormer: Mismatch in parent while loading dormer');
                    }
                }
                else if (children[i].type === HippedDormer.getObjectType()) {
                    const dormer = new SmartroofModel(this.stage);
                    currentObject = dormer;
                    this.addChild(dormer);
                    this.loadDormerBackwardsCompatibility(dormer, children[i]);
                    if (dormer.getParent() !== this) {
                        console.error('HippedDormer: Mismatch in parent while loading dormer');
                    }
                }
                else if (this.stage.checkObjectTypeCylinderModel(children[i])) {
                    const cylinderModel = this.stage.initializeCylinderModel();
                    currentObject = cylinderModel;
                    this.addChild(cylinderModel);
                    cylinderModel.loadObject(children[i], isPaste);
                    if (cylinderModel.getParent() !== this) {
                        console.error('PolygonModel: Mismatch in parent while loading PolygonModel');
                    }
                }
                else if (children[i].type === Tree.getObjectType()) {
                    const tree = new Tree(this.stage);
                    currentObject = tree;
                    this.addChild(tree);
                    tree.loadObject(children[i], isPaste);
                    if (tree.getParent() !== this) {
                        console.error('PolygonModel: Mismatch in parent while loading PolygonModel');
                    }
                }
                else if (children[i].type === Inverter.getObjectType()) {
                    if (!isPaste) {
                        const inverter = new Inverter(this.stage);
                        currentObject = inverter;
                        this.addChild(inverter);
                        inverter.loadObject(children[i], isPaste);
                        if (inverter.getParent() !== this) {
                            console.error('PolygonModel: Mismatch in parent while loading Inverter');
                        }
                    }
                }
                else if (children[i].type === HybridInverter.getObjectType()) {
                    if (!isPaste) {
                        const inverter = new HybridInverter(this.stage);
                        currentObject = inverter;
                        this.addChild(inverter);
                        inverter.loadObject(children[i], isPaste);
                        if (inverter.getParent() !== this) {
                            console.error('PolygonModel: Mismatch in parent while loading Hybrid Inverter');
                        }
                    }
                }
                else if (children[i].type === ACDB.getObjectType()) {
                    const acdb = new ACDB(this.stage);
                    currentObject = acdb;
                    this.addChild(acdb);
                    acdb.loadObject(children[i], isPaste);
                    if (acdb.getParent() !== this) {
                        console.error('PolygonModel: Mismatch in parent while loading ACDB');
                    }
                }
                else if (children[i].type === DCDB.getObjectType()) {
                    if (!isPaste) {
                        const dcdb = new DCDB(this.stage);
                        currentObject = dcdb;
                        this.addChild(dcdb);
                        dcdb.loadObject(children[i], isPaste);
                        if (dcdb.getParent() !== this) {
                            console.error('PolygonModel: Mismatch in parent while loading DCDB');
                        }
                    }
                }
                else if (children[i].type === Subarray.getObjectType()) {
                    const subarray = new Subarray(this.stage);
                    currentObject = subarray;
                    subarray.loadObject(children[i], this, isPaste).then(() =>
                    {this.updateRafter()});
                }
                else if (children[i].type === Walkway.getObjectType()) {
                    const walkway = new Walkway(this.stage);
                    currentObject = walkway;
                    this.addChild(walkway);
                    walkway.loadObject(children[i], isPaste);
                }
                else if (children[i].type === SafetyLine.getObjectType()) {
                    const safetyLine = new SafetyLine(this.stage);
                    currentObject = safetyLine;
                    this.addChild(safetyLine);
                    safetyLine.loadObject(children[i], isPaste);
                }
                else if (children[i].type === Handrail.getObjectType()) {
                    const handrail = new Handrail(this.stage);
                    currentObject = handrail;
                    this.addChild(handrail);
                    handrail.loadObject(children[i], isPaste);
                }
                else if (children[i].type === AcCable.getObjectType()) {
                    const acCable = new AcCable(this.stage);
                    currentObject = acCable;
                    this.addChild(acCable);
                    acCable.loadObject(children[i], isPaste);
                }
                else {
                    console.error('PolygonModel: Invalid object type in loadObject');
                }
            }
            catch (error) {
                console.error('Unable to load children of smartroof face', error);
                notificationsAssistant.error({
                    title: 'Load Error',
                    message: 'Error loading object. Please contact support.',
                });
                currentObject.removeObject();
            }
        }
        if (isPaste) {
            this.saveState({ withoutContainer: false });
        } else {
            this.saveState({ withoutContainer: true });
        }
    }

    loadState(state, fromState) {
        if (state === CREATED_STATE || state === DELETED_STATE) {
            this.clearState();
            this.removeEdges();
        }
        else {
            // load id and name
            this.id = state.id;
            this.name = state.name;

            // load polygon properties
            this.attachmentSpacingMultiplier = state.attachmentSpacingMultiplier;
            this.attachmentType = state.attachmentType;
            this.updatedAttachmentRow = state.updatedAttachmentRow.map(elem => ({
                offset: elem.offset,
                rowId: elem.rowId,
            }));
            this.attachmentRow = state.attachmentRow;
            this.tilt = this.getValidTilt(state.tilt);
            this.rafterEnabled = state.rafterEnabled;
            this.rafterOrientation = state.rafterOrientation;
            this.rafterSpacing = state.rafterSpacing;
            this.rafterOffset = state.rafterOffset;
            this.isDeleted = state.isDeleted;
            this.azimuth = state.azimuth;
            this.setbackInside = state.setbackInside;
            this.isValid = state.isValid;
            this.ignored = state.ignored;
            this.placable = state.placable;
            this.coreHeight = state.coreHeight;
            this.edge = state.edge;
            this.updateVisualsAfterLoadingAndCreation();
            // update parent
            const parentObject = this.stage.getObject(state.parent);
            if (parentObject && this.getParent() !== parentObject) {
                this.changeParent(parentObject);
            }
            if (fromState === CREATED_STATE || fromState === DELETED_STATE) {
                
                // add objectsGroup to scene
                this.stage.sceneManager.scene.add(this.objectsGroup);

                this.roofFaceVertices = [];
                state.roofFaceVertices.forEach((vertex) => {
                    if(this.stage.penTool.pointsMap.has(`${vertex[0].toFixed(4)},${vertex[1].toFixed(4)}`)){
                        const vertexPoint = this.stage.penTool.pointsMap.get(`${vertex[0].toFixed(4)},${vertex[1].toFixed(4)}`);
                        vertexPoint.zValueMap.set(this.uuid, vertex[2]);
                        this.roofFaceVertices.push(vertexPoint);
                    }
                    else{
                        const vertexPoint = new FaceVertex(this.stage, this, new THREE.Vector3(vertex[0], vertex[1], vertex[2]), [], false, this.stage.penTool);
                        vertexPoint.zValueMap.set(this.uuid, vertex[2]);
                        this.stage.penTool.pointsMap.set(`${vertex[0].toFixed(4)},${vertex[1].toFixed(4)}`, vertexPoint);
                        this.roofFaceVertices.push(vertexPoint);
                        this.parent.faceVertices.push(vertexPoint);
                    }
                });
                let flag = true;
                this.parent.roofFaces.forEach(face => {
                    if((face.uuid === this.uuid)){
                        flag = false;
                    }
                });
                
                if(flag) this.parent.roofFaces.push(this);

                this.createEdges();
                this.edges.forEach(edge => {
                    if(edge.edgeHash === state.primaryEdge){
                        this.primaryEdge = edge;
                    }
                });
                // create polygon measurement
                // if (this.isValid) {
                //     this.polygonMeasurement = new PolygonMeasurement(
                //         this.oldVertices,
                //         this, this.stage, false,
                //     );
                // }
            }
            else if (this.roofFaceVertices.length === state.roofFaceVertices.length) {
                this.roofFaceVertices.forEach((vertex, index) => {
                    vertex.setPosition(state.roofFaceVertices[index][0], state.roofFaceVertices[index][1], state.roofFaceVertices[index][2]);
                    // Update values in existing map
                    for (const [key, value] of state.roofFaceVertices[index][3]) {
                        vertex.zValueMap.set(key, value);
                    }
                });

                this.parent.parent.updatePointsMap();
            }
            else if (this.roofFaceVertices.length !== state.roofFaceVertices.length) {


                // this.roofFaceVertices = state.roofFaceVertices.map(vertex => new FaceVertex(this.stage, this, new THREE.Vector3(vertex[0], vertex[1], vertex[2]), [], false, this.parent.parent));
                this.createEdges();
                this.edges.forEach(edge => {
                    if(edge.edgeHash === state.primaryEdge){
                        this.primaryEdge = edge;
                    }
                });
                // create polygon measurement
                // if (this.isValid) {
                //     this.polygonMeasurement = new PolygonMeasurement(
                //         this.oldVertices,
                //         this, this.stage, false,
                //     );
                // }
            }
            else {
                console.error('PitchedRoof Face: loadState: Error in Loading Outline Points');
                return null;
            }

            // if (this.stage.selectionControls.getSelectedObject() === this) {
            //     // update polygon measurement
            //     // this.updatePolygonMeasurement();
            //     // this.polygonMeasurement.show();
            // }
            // update geometry
            this.editedVertices = [];
            state.editedVertices.forEach(x => {
                this.editedVertices.push(new THREE.Vector3(x[0],x[1],x[2]));
            })
            // this.updatedEditedFace();

            this.updateGeometry();
            this.parent.updateGeometry();
            this.parent.getAllSmartroofIntersections();
            this.updatePlane();
            this.updateSetback();
            this.updateRafter();
            this.updateRail();
            if (this.isValidFace()) {
                this.stage.quadTreeManager.handlePlaceObject(this);
                this.stage.ground.faces.add(this);
            }
        }
        return true;
    }
    
    getState() {
        const polygonData = {
            id: this.id,
            uuid: this.uuid,
            name: this.name,
            tilt: this.tilt,
            rafterEnabled: this.rafterEnabled,
            rafterOrientation: this.rafterOrientation,
            rafterSpacing: this.rafterSpacing,
            rafterOffset: this.rafterOffset,
            attachmentSpacingMultiplier: this.attachmentSpacingMultiplier,
            attachmentType: this.attachmentType,
            updatedAttachmentRow: this.updatedAttachmentRow.map(elem => ({
                offset: elem.offset,
                rowId: elem.rowId,
            })),
            attachmentRow: this.attachmentRow,
            isDeleted: this.isDeleted,
            azimuth: this.azimuth,
            isValid: this.isValid,
            coreHeight: this.coreHeight,
            setbackInside: this.setbackInside,
            ignored: this.ignored,
            placable: this.placable,
            plane: this.plane,
            edge: this.edge,
            editedVertices: this.editedVertices.map(editedVertex => [
                editedVertex.x,
                editedVertex.y,
                editedVertex.z,
            ]),

            parent: this.getParent() ? this.getParent().uuid : null,
            roofFaceVertices : this.saveFaceVertices(),
            primaryEdge: (this.primaryEdge === null)? null: this.primaryEdge.edgeHash,
        };
        return polygonData;
    }
    saveFaceVertices() {
        const roofFaceVertices = [];
        this.roofFaceVertices.forEach((vertex) => {
            roofFaceVertices.push([
                vertex.vertex.x,
                vertex.vertex.y,
                vertex.zValueMap.get(this.uuid),
                new Map(vertex.zValueMap),
            ]);
        });
        return roofFaceVertices;
    }

    clearState() {
        // select ground if selected
        if (this.stage.selectionControls.getSelectedObject() === this) {
            this.stage.selectionControls.setSelectedObject(this.stage.ground);
        }

        this.stage.quadTreeManager.removeObject(this);
        this.stage.ground.faces.delete(this);


        this.stage.sceneManager.scene.remove(this.objectsGroup);

        //remove roofFaceVertices
        for(let i = 0; i < this.roofFaceVertices.length; i++){
            this.roofFaceVertices[i].zValueMap.delete(this.uuid);
            if(this.roofFaceVertices[i].zValueMap.size === 0){
                this.stage.penTool.pointsMap.delete(`${this.roofFaceVertices[i].vertex.x.toFixed(4)},${this.roofFaceVertices[i].vertex.y.toFixed(4)}`);
                this.parent.faceVertices.forEach((vertex, index) => {
                    if(vertex.vertex.x === this.roofFaceVertices[i].vertex.x && vertex.vertex.y === this.roofFaceVertices[i].vertex.y){
                        this.parent.faceVertices.splice(index, 1);
                    }
                });
                this.roofFaceVertices[i].removeObject();
            }
        }
        this.roofFaceVertices = [];
        this.parent.updateGeometry();
        this.parent.getAllSmartroofIntersections();
        this.parent.roofFaces.forEach((face, index) => {
            if(face.uuid === this.uuid){
                this.parent.roofFaces.splice(index, 1);
            }
        });
        this.getParent().removeChild(this);
        // remove measurements
        // if (this.polygonMeasurement) this.polygonMeasurement.remove();
    }
    async updateObject(properties, flag = false) {
        let updateGeometryRequired = false;
        // let handleChildrenRequired = false;
        let tiltChanged = false;
        const options = {
            heightChanged: false,
            prevHeight: null,
            parapetHeightChanged: false,
            prevParapetHeight: null,
            parapetThicknessChanged: false,
        };

        if (Object.prototype.hasOwnProperty.call(properties, 'name') &&
            properties.name !== this.name) {
            this.name = properties.name;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'height') &&
            properties.height != this.getHeight()) {
                this.heightChange(properties.height, true);
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'tilt') &&
            properties.tilt != parseFloat(this.tilt).toFixed(2)) {
            updateGeometryRequired = updateGeometryRequired || true;
            // handleChildrenRequired = true;
            const validTilt = this.getValidTilt(properties.tilt);
            this.tilt = validTilt;
            tiltChanged = true;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'rafterEnabled') &&
            properties.rafterEnabled !== this.rafterEnabled) {
            updateGeometryRequired = updateGeometryRequired || true;                
            this.rafterEnabled = properties.rafterEnabled;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'rafterOrientation') &&
            properties.rafterOrientation !== this.rafterOrientation) {
            updateGeometryRequired = updateGeometryRequired || true;                
            this.rafterOrientation = properties.rafterOrientation;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'rafterSpacing') &&
            properties.rafterSpacing !== this.rafterSpacing) {
            updateGeometryRequired = updateGeometryRequired || true;                
            this.rafterSpacing = properties.rafterSpacing;
            this.updatedAttachmentRow = [];
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'attachmentType') &&
            properties.attachmentType !== this.attachmentType) {
            updateGeometryRequired = updateGeometryRequired || true;                
            this.attachmentType = properties.attachmentType;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'attachmentSpacingMultiplier') &&
            properties.attachmentSpacingMultiplier !== this.attachmentSpacingMultiplier) {
            updateGeometryRequired = updateGeometryRequired || true;                
            this.attachmentSpacingMultiplier = properties.attachmentSpacingMultiplier;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'placable') &&
            properties.placable !== this.placable) {
            updateGeometryRequired = updateGeometryRequired || false;
            this.placable = properties.placable;
        }
        if (Object.prototype.hasOwnProperty.call(properties, 'setbackInside') &&
            properties.setbackInside !== this.setbackInside) {
            updateGeometryRequired = updateGeometryRequired || true;

            if (properties.setbackInside !== 'custom') {
                const setbackValues = [];
                for (let i = 0, len = this.setbackVertices.length; i < len; i += 1) {
                    const vertices2DVectorArray = this.setbackVertices[i];
                    const setbackArray = [];
                    for (let j = 0, lenn = vertices2DVectorArray.length; j < lenn; j += 1) {
                        setbackArray.push(properties.setbackInside);
                    }
                    setbackValues.push(setbackArray);
                }
                this.setbackInside = setbackValues;
            }
        }

        if (updateGeometryRequired) {
            try {
                this.handlePropertiesUpdate(options);
            }
            catch (error) {
                console.error('ERROR: PolygonModel: Update failed', error);
                return Promise.reject(error);
            }
        }

        if (this.isSelected) {
            this.onSelect();
        }
        this.parent.placeObject();
        this.editedVertices = this.vertices.map(v => new THREE.Vector3(v.x, v.y, v.z));
        this.stage.mergeManager.mergeScene(this);
        return Promise.resolve(true);
    }

    handlePropertiesUpdate() {
        this.updateSetback();
        this.updateGeometry();
        this.updateRafter();
        this.updateRails();
        this.parent.updateGeometry();
    }


    deleteFace() {
        let verticesClone = this.vertices.map(vertex => new THREE.Vector3(vertex.x, vertex.y, vertex.z));
        verticesClone.push(verticesClone[0]);
        let completeLoopClone = this.parent.completeLoopFaceVertices.map((vertex) => vertex.getPosition());
        completeLoopClone.push(completeLoopClone[0]);

        let completeLoop = (this.parent.isAutomated)?this.parent.completeLoop:this.parent.parent.mergePolygons(completeLoopClone, verticesClone);

        if(completeLoop.length <= MINIMUM_NUMBER_OF_POINTS && !this.parent.isAutomated){
            this.stage.eventManager.setPenToolFaceDelete();
            return;
        }
        
        const siblings = this.getParent().getChildren();
        let stopDeletion = true;
        for (let i = 0; i < siblings.length; i += 1) {
            if (!siblings[i].isDeleted && siblings[i] !== this) {
                stopDeletion = false;
            }
        }
        if (stopDeletion) {
            this.stage.eventManager.invalidFaceDeletion();
            this.stage.selectionControls.setSelectedObject(this.stage.ground);
            return;
        }
        this.stage.stateManager.startContainer();
        if (this.fold) {
            this.fold.isActive = false;
        }
        for(let i = 0; i < this.roofFaceVertices.length; i++){
            this.roofFaceVertices[i].zValueMap.delete(this.uuid);
            if(this.roofFaceVertices[i].zValueMap.size === 0){
                this.parent.parent.pointsMap.delete(`${this.roofFaceVertices[i].vertex.x.toFixed(4)},${this.roofFaceVertices[i].vertex.y.toFixed(4)}`);
                this.parent.faceVertices.forEach((vertex, index) => {
                    if(vertex.vertex.x === this.roofFaceVertices[i].vertex.x && vertex.vertex.y === this.roofFaceVertices[i].vertex.y){
                        this.parent.faceVertices.splice(index, 1);
                    }
                });
                this.roofFaceVertices[i].removeObject();
            }
        }
        this.parent.roofFaces.forEach((face, index) => {
            if(face.uuid === this.uuid){
                this.parent.roofFaces.splice(index, 1);
            }
        });
        this.plane = this.outerPlane;
        this.isDeleted = true;
        this.rafterEnabled = false;
        this.updateRafter();
        const i = 0;
        while (this.getChildren().length > i) {
            this.getChildren()[i].removeObject();
        }
        this.stage.stateManager.add({
            uuid: this.uuid,
            getStateCb: () => DELETED_STATE,
        });
        this.isValid = false;
        this.stage.ground.faces.delete(this);
        this.parent.createCompleteLoop(completeLoop);
        this.parent.updateGeometry();
        this.parent.getAllSmartroofIntersections();
        this.parent.saveState();
        this.parent.removeChild(this);
        // this.getParent().updateFacesWithNewAngles();
        this.stage.stateManager.stopContainer();
        this.stage.selectionControls.setSelectedObject(this.stage.ground);
        this.isDeleted = true;
    }

    getVector3DVertices() {
        const vertices = [];
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            const outlinePoint = this.roofFaceVertices[i].getPosition();
            let z = this.roofFaceVertices[i].zValueMap.get(this.uuid);
            if(z === undefined) z = this.coreHeight;
            vertices.push(new THREE.Vector3(outlinePoint.x, outlinePoint.y,z));
        }
        return vertices;
    }
    get2DVertices() {
        const vertices = [];
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            vertices.push([
                this.roofFaceVertices[i].getPosition().x,
                this.roofFaceVertices[i].getPosition().y,
            ]);
        }
        return vertices;
    }

    get2DVectorVertices() {
        const vertices = [];
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            vertices.push(this.roofFaceVertices[i].getPosition());
        }
        return vertices;
    }

    getVector2Vertices() {
        const vertices = [];
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            const pos = this.roofFaceVertices[i].getPosition();
            vertices.push(new THREE.Vector2(pos.x, pos.y));
        }
        return vertices;
    }

    get3DVertices() {
        const vertices = [];
        for (let i = 0, len = this.roofFaceVertices.length; i < len; i += 1) {
            const outlinePoint = this.roofFaceVertices[i].getPosition();
            let z = this.roofFaceVertices[i].zValueMap.get(this.uuid);
            if(z === undefined) z = this.coreHeight;
            vertices.push([
                outlinePoint.x,
                outlinePoint.y,
                z
            ]);
        }
        return vertices;
    }

    getCleaned3DVertices() {
        const vertices = this.get3DVertices().map((vertex) => {
            return new THREE.Vector3(vertex[0], vertex[1], vertex[2]);
        });

        this.removeCollinearVertices(vertices);

        return vertices.map(vertex => [vertex.x, vertex.y, vertex.z]);
        
    }

    removeCollinearVertices(vertices) {
        if (!vertices || vertices.length < 3) {
            return;
        }
        // Remove collinear points
        let collinearFlag = true;
        while(collinearFlag) {
            collinearFlag = false;
            for (let i = 0; i < vertices.length; i += 1) {
                const vertex = vertices[i];
                const vertexNext = vertices[(i + 1) % vertices.length];
                const vertexPrev = vertices[((i - 1) + vertices.length) % vertices.length];
                if (utils.checkCollinear(vertex, vertexNext, vertexPrev, 0.0001)) {
                    vertices.splice(i, 1);
                    i -= 1;
                }
            }
        }
    }

    getZOnTopSurface(x, y) {
        // get z calculation not valid for pen tool roof face
        return this.getZOnPlane(x, y);
        if (this.roofFaceVertices.length === 0) {
            console.error('ERROR: PolygonModel: has outline points null');
        }
        const v1 = this.roofFaceVertices[0].getPosition();
        v1.z = (this.roofFaceVertices[0].zValueMap.get(this.uuid) === undefined) ? this.coreHeight : this.roofFaceVertices[0].zValueMap.get(this.uuid);
        let v2 = this.roofFaceVertices[1].getPosition();
        v2.z = this.roofFaceVertices[1].zValueMap.get(this.uuid) === undefined ? this.coreHeight : this.roofFaceVertices[1].zValueMap.get(this.uuid);
        const v3 = this.roofFaceVertices[2].getPosition();
        v3.z = this.roofFaceVertices[2].zValueMap.get(this.uuid) === undefined ? this.coreHeight : this.roofFaceVertices[2].zValueMap.get(this.uuid);
        v1.addScaledVector(v2, -1);
        v3.addScaledVector(v2, -1);
        v1.cross(v3);
        v2 = this.roofFaceVertices[1].getPosition();
        v2.z = this.roofFaceVertices[1].zValueMap.get(this.uuid) === undefined ? this.coreHeight : this.roofFaceVertices[1].zValueMap.get(this.uuid);
        const d = -1 * ((v1.x * v2.x) + (v1.y * v2.y) + (v1.z * v2.z));
        return -1 * ((d / v1.z) + ((v1.y * y) / v1.z) + ((v1.x * x) / v1.z));
    }
    getZOnPlane (x, y) {
        // Ensure the plane is normalized
        this.plane.normal.normalize();
        
        // Calculate z using the this.plane equation: ax + by + cz + d = 0
        const a = this.plane.normal.x;
        const b = this.plane.normal.y;
        const c = this.plane.normal.z;
        const d = this.plane.constant;
        
        const z = (-d - a * x - b * y) / c;
        
        return z;
    }

    get numVertices() {
        return this.roofFaceVertices.length;
    }

    updateSetback() {
        SmartroofModel.removeCollinearVertices(this.setbackVertices);
        if (this.roofFaceVertices.length !== 0 && !this.isDeleted) {
            let setbackInsideGeometryVertices;
            if (!this.isValid) {
                if (this.setbackInsideMesh && this.setbackInsideMesh.geometry) this.setbackInsideMesh.geometry.dispose();
                this.setbackInsideMesh.geometry = new THREE.BufferGeometry();
                setbackInsideGeometryVertices = [];
            }
            try {
                if (this.setbackInsideMesh && this.setbackInsideMesh.geometry) this.setbackInsideMesh.geometry.dispose();
                this.setbackInsideMesh.geometry = this.getSetbackInsideGeometry();
                setbackInsideGeometryVertices = this.setbackInsideMesh.geometry.attributes.position;
                if (setbackInsideGeometryVertices) {
                    for (let index = 0; index < setbackInsideGeometryVertices.count; index++) {
                        setbackInsideGeometryVertices.array[(3 * index) + 2] = this.getZOnPlane(
                            setbackInsideGeometryVertices.array[(3 * index)],
                            setbackInsideGeometryVertices.array[(3 * index) + 1],
                        ) + 0.01;
                    }
                    this.setbackInsideMesh.geometry.attributes.position = setbackInsideGeometryVertices;
                    this.setbackInsideMesh.geometry.attributes.position.needsUpdate = true;
                }
            }
            catch (error) {
                // console.error('Unable to create inner setback for face', error);
                if (this.setbackInsideMesh && this.setbackInsideMesh.geometry) this.setbackInsideMesh.geometry.dispose();
                this.setbackInsideMesh.geometry = new THREE.BufferGeometry();
                setbackInsideGeometryVertices = [];
            }


            // for (let i = 0; i < setbackInsideGeometryVertices.length; i++) {
            //     setbackInsideGeometryVertices[i].z = this.getZOnPlane(setbackInsideGeometryVertices[i].x, setbackInsideGeometryVertices[i].y) + 0.01;
            // }
            // Might need reassigning?
            // setbackInsideGeometryVertices.needsUpdate = true;
        }
        this.setbackInsideMesh.position.z = 0.01;
        this.saveState();
    }

    getFacePlane() {
        const outlinePoint1Vertex = this.primaryEdge.outlinePoint1.vertex;
        const outlinePoint2Vertex = this.primaryEdge.outlinePoint2.vertex;
        const outlinePoint3Vertex = this.roofFaceVertices[2].vertex;
        outlinePoint1Vertex.z = this.primaryEdge.outlinePoint1.zValueMap.get(this.uuid) === undefined ? this.coreHeight : this.primaryEdge.outlinePoint1.zValueMap.get(this.uuid);
        outlinePoint2Vertex.z = this.primaryEdge.outlinePoint2.zValueMap.get(this.uuid) === undefined ? this.coreHeight : this.primaryEdge.outlinePoint2.zValueMap.get(this.uuid);
        outlinePoint3Vertex.z = this.roofFaceVertices[2].zValueMap.get(this.uuid) === undefined ? this.coreHeight : this.roofFaceVertices[2].zValueMap.get(this.uuid);
        const plane = new THREE.Plane().setFromNormalAndCoplanarPoint(this.getPlaneNormal(this.tilt, outlinePoint1Vertex, outlinePoint2Vertex), outlinePoint3Vertex);
        return plane
    }

    updateOutlinePoints(vertices, place = true) {
        let flag = false;
        if (this.oldVertices && vertices) flag = this.oldVertices.length === vertices.length;
        this.oldVertices = vertices;
        this.setbackVertices = [[]];
        // this.roofFaceVertices = [];
        if (vertices) {
            for (let i = 0; i < vertices.length; i++) {
                // if(this.parent.parent.pointsMap.has(`${vertices[i].x.toFixed(4)},${vertices[i].y.toFixed(4)}`)){
                //     const vertexPoint = this.parent.parent.pointsMap.get(`${vertices[i].x.toFixed(4)},${vertices[i].y.toFixed(4)}`);
                //     vertexPoint.zValueMap.set(this.uuid, vertices[i].z);
                //     this.roofFaceVertices.push(vertexPoint);
                // }
                this.setbackVertices[0].push(new THREE.Vector3(
                    vertices[i].x,
                    vertices[i].y,
                    vertices[i].z,
                ));
            }

            if (this.stage.selectionControls.getSelectedObject() === this) {
                // if (this.polygonMeasurement != null && flag) this.updatePolygonMeasurement();
                // else this.createPolygonMeasurement();
                this.showMeasurement();
                const selectionOutLinePoints = this.outlinePoints;
                for (let i = 0; i < selectionOutLinePoints.length; i += 1) {
                    selectionOutLinePoints[i].showObject();
                }
            }
            this.azimuth = this.findAzimuth();
            this.salesAzimuth = this.azimuth;
            if (place) {
                if (this.isValidFace() ) {
                    this.stage.quadTreeManager.handlePlaceObject(this);
                }
                else {
                    this.stage.quadTreeManager.removeObject(this);
                }
            }
            if(this.isValidFace()) {
                this.stage.ground.faces.add(this);
            }
            else {
                this.stage.ground.faces.delete(this);
            }

            // TODO: Jugaad, fix for moveObject of safety line and handrail
            utils.updateHandrailAndSafetyLineForMove(this);
        }
        else {
            this.hideMeasurement();
            this.stage.quadTreeManager.removeObject(this);
            this.stage.ground.faces.delete(this);
        }
        if (this.rafterEnabled && !this.stage.visualManager.in3D) {
            // remove the rails and rafters when the roof is dynamically updated
            this.disposeAttachments();
            this.disposeRails();
        }
        if(this.editedVertices.length === 0 && vertices) {
            this.editedVertices = vertices;
        }
        this.setFeatureVisibility();

        // this.setbackVerticesReset = true;
    }

    static validateObject(polygonModelData) {
        if (!polygonModelData.isValid) {
            return { isValid: true };
        }
        let allOutlinePointsZero = true;
        for (let i = 0, len = polygonModelData.roofFaceVertices.length; i < len; i += 1) {
            if (!(polygonModelData.roofFaceVertices[i][0] === 0 &&
                    polygonModelData.roofFaceVertices[i][1] === 0 &&
                    polygonModelData.roofFaceVertices[i][2] === 0)) {
                allOutlinePointsZero = false;
                break;
            }
        }
        if (allOutlinePointsZero) {
            return { isValid: false };
        }

        if (polygonModelData.setbackInside === undefined) {
            polygonModelData.setbackInside = [[]];
        }
        return { isValid: true };
    }
}